// @ts-nocheck
import React from "react";

export const BarChart = ({ data, valueKey, labelKey, maxVal }) => {
  const max = maxVal || Math.max(...data.map((d) => d[valueKey]));
  return (
    <div className="space-y-2">
      {data.map((d, i) => (
        <div key={i} className="flex items-center gap-3">
          <span className="text-xs text-slate-500 dark:text-slate-400 w-10 text-right">
            {d[labelKey]}
          </span>
          <div className="flex-1 h-5 bg-slate-100 dark:bg-slate-800 rounded overflow-hidden">
            <div
              className="h-full bg-indigo-500 rounded transition-all"
              style={{ width: `${(d[valueKey] / max) * 100}%` }}
            />
          </div>
          <span className="text-xs font-medium text-slate-700 dark:text-slate-300 w-16 text-right">
            ${(d[valueKey] / 1000).toFixed(1)}K
          </span>
        </div>
      ))}
    </div>
  );
};
